import { ReactNode } from 'react';

interface MainLayoutProps {
  children: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className="flex h-dvh flex-col">
      <main className="flex min-h-0 flex-1 flex-col bg-white">{children}</main>
    </div>
  );
};
